module.exports = __webpack_public_path__ + "62c8edb6917ada41df1a2774edb37514.png";